__turbopack_context__.v({
  "autoFit": "CardGrid-module__u1XtPG__autoFit",
  "grid": "CardGrid-module__u1XtPG__grid",
  "item": "CardGrid-module__u1XtPG__item",
});
